import { useMemo, type CSSProperties } from 'react';
import { useResolvedTheme } from '@/theme/theme';
import { avatarUri, type AvatarArtId } from './avatars';
import type { ArtTheme } from './covers/kit';

/** One preset avatar (art/avatars.ts), round, follows the theme. Decorative. */
export function AvatarArt({ id, size, className, style, theme }: { id: AvatarArtId; size: number | string; className?: string; style?: CSSProperties; theme?: ArtTheme }) {
  const current = useResolvedTheme();
  const t = theme ?? current;
  const src = useMemo(() => avatarUri(id, t), [id, t]);
  return (
    <img
      src={src}
      alt=""
      aria-hidden="true"
      draggable={false}
      width={typeof size === 'number' ? size : undefined}
      height={typeof size === 'number' ? size : undefined}
      className={className}
      style={{ display: 'block', flex: 'none', borderRadius: '50%', width: size, height: size, ...style }}
    />
  );
}
